import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Brand } from "../components/Brand";

export function InvitationVerification() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status") ?? "";
  const authError = searchParams.get("error") ?? "";
  const renewalToken = searchParams.get("renewalToken") ?? "";
  const automaticallyRenewing = Boolean(authError && renewalToken);
  const verified = status === "verified" || (!status && !authError && Boolean(renewalToken));

  useEffect(() => {
    if (!automaticallyRenewing) return;
    window.location.replace(
      `/api/invitations/verify-email/${encodeURIComponent(renewalToken)}?renew=1`,
    );
  }, [automaticallyRenewing, renewalToken]);

  let title = "Verification link unavailable";
  let message =
    "This one-time link is invalid or has already been replaced. Please use the latest invitation email.";
  let icon = "fa-circle-exclamation";
  let role: "status" | "alert" = "alert";

  if (verified) {
    title = "Email address verified";
    message = "Your email address has been verified. You can now continue to FMC Leads Manager.";
    icon = "fa-check";
    role = "status";
  } else if (status === "complete") {
    title = "Email already verified";
    message = "This account is already active. You can sign in using your existing password.";
    icon = "fa-check";
    role = "status";
  } else if (status === "expired") {
    title = "Verification link expired";
    message =
      "We have automatically sent a new verification email to the address originally invited. The new one-time link will be valid for 24 hours.";
    icon = "fa-envelope";
    role = "status";
  } else if (status === "delivery-error") {
    title = "New link could not be sent";
    message =
      "We could not send a replacement verification email just now. Please try the link again or contact your FMC representative if the problem continues.";
  } else if (automaticallyRenewing) {
    title = "Refreshing your verification link";
    message =
      "This link can no longer be used. We are sending a new 24-hour link to the address originally invited.";
    icon = "fa-envelope";
    role = "status";
  }

  return (
    <div className="min-h-screen bg-surface-light flex flex-col items-center justify-center px-6 py-12">
      <div className="w-full max-w-[420px]">
        <div className="flex justify-center mb-8">
          <Brand logoHeight={62} align="center" />
        </div>
        <div className="bg-surface-white border border-default rounded-xl px-[30px] py-[30px]">
          <div role={role} className="flex flex-col items-start gap-4">
            <span className="w-10 h-10 rounded-full bg-brand-red-tint text-brand-red flex items-center justify-center">
              <i className={`fa-solid ${icon}`} aria-hidden="true" />
            </span>
            <div>
              <h1 className="text-title-md font-bold text-primary">{title}</h1>
              <p className="text-body text-secondary mt-1">{message}</p>
            </div>
            <Link
              to="/login"
              className="h-11 w-full rounded-xs bg-brand-red text-on-brand text-body font-semibold flex items-center justify-center"
            >
              Continue to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
